<template>
  <div>
    <div class="auto-overflow">
      <table id="table-details">
        <thead>
          <tr>
            <th class="ts-whitespace-no-wrap" style="width:200px">
              {{ $t('paymentTesting.feeName') }}
            </th>
            <th class="ts-whitespace-no-wrap" style="width: 190px;">
              {{ $t('paymentTesting.description') }}
            </th>
            <th class="ts-whitespace-no-wrap" style="width: 99px;">
              {{ $t('paymentTesting.fee') }}
            </th>
            <th class="ts-whitespace-no-wrap" style="width: 93px;">
              {{ $t('paymentTesting.discountType') }}
            </th>
            <th class="ts-whitespace-no-wrap" style="width: 94px;">
              {{ $t('paymentTesting.discount') }}
            </th>
            <th class="ts-whitespace-no-wrap" style="width: 81px;">
              {{ $t('paymentTesting.vat') }}(%)
            </th>
            <th class="ts-whitespace-no-wrap" style="width: 90px;">
              {{ $t('paymentTesting.amount') }}
            </th>
            <th style="width:1%">
              <a href="#" class="text-primary" @click.prevent="addRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(detail, index) in model.fee_detail_list" :key="index">
            <td valign="top">
              <a-select
                v-model="detail.fee_setup_id"
                style="width:100%"
                :options="feeSetupOption"
                @change="handleFeeChange(detail)"
              ></a-select>
              <div
                class="validate"
                v-if="errors.has('fee_detail_list.' + index + '.fee_setup_id')"
              >
                {{ errors.first('fee_detail_list.' + index + '.fee_setup_id') }}
              </div>
            </td>
            <td valign="top">
              <input
                v-model.trim="detail.fee_description"
                type="text"
                class="form-control"
              />
            </td>
            <td valign="top">
              <input
                v-model.number="detail.fee_amount"
                type="number"
                class="form-control"
                readonly
              />
              <div
                class="validate"
                v-if="errors.has('fee_detail_list.' + index + '.fee_amount')"
              >
                {{ errors.first('fee_detail_list.' + index + '.fee_amount') }}
              </div>
            </td>
            <td valign="top">
              <a-select
                v-model="detail.discount_type"
                style="width: 100%"
                :options="[
                  { value: '$', label: '$' },
                  { value: '%', label: '%' }
                ]"
                @change="calculate"
              />
            </td>
            <td valign="top">
              <input
                v-model.number="detail.discount_rate"
                type="number"
                class="form-control"
                @input="calculate"
              />
            </td>
            <td valign="top">
              <input
                v-model.number="detail.vat_rate"
                type="number"
                class="form-control"
                @input="calculate"
              />
            </td>
            <td valign="top">
              <input
                v-model="detail.total_amount"
                type="number"
                class="form-control"
                readonly
              />
              <div
                class="validate"
                v-if="errors.has('fee_detail_list.' + index + '.total_amount')"
              >
                {{ errors.first('fee_detail_list.' + index + '.total_amount') }}
              </div>
            </td>
            <td>
              <a
                href="#"
                class="text-red"
                valign="middle"
                @click.prevent="removeRow(detail)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'paymentTestingItemDetails',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      errors: new Errors(),
      newRow: {
        fee_setup_id: null,
        fee_description: null,
        fee_amount: null,
        discount_type: '%',
        discount_rate: 0,
        discount_amount: null,
        discount_reason: null,
        total_amount: null,
        vat_rate: 0,
        vat_amount: null,
        amount_include_vat: null
      }
    }
  },
  computed: {
    ...mapState('paymentTesting', ['feeSetupLists']),
    feeSetupOption() {
      return this.feeSetupLists.map(el => ({
        value: el.fee_setup_id,
        label: el.fee_name_en
      }))
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    addRow() {
      this.model.fee_detail_list.push(_.clone(this.newRow))
    },
    removeRow(row) {
      this.model.fee_detail_list.splice(
        this.model.fee_detail_list.indexOf(row),
        1
      )
      this.calculate()
    },
    handleFeeChange(detail) {
      let result = this.feeSetupLists
        .filter(f => f.fee_setup_id == detail.fee_setup_id)
        .reduce((init, item) => (init = item), {})
      detail.fee_description = result.fee_name_en
      detail.fee_amount = result.fee_amount

      this.calculate()
    },
    calculate() {
      if (this.model.fee_detail_list.length > 0) {
        this.model.fee_detail_list.forEach(detail => {
          if (detail.discount_type == '%') {
            detail.discount_amount = detail.discount_rate
              ? detail.fee_amount * _.ceil(detail.discount_rate / 100, 4)
              : 0
          }
          if (detail.discount_type == '$') {
            detail.discount_amount = detail.discount_rate
          }
          detail.total_amount = detail.fee_amount - detail.discount_amount
          detail.vat_amount = detail.vat_rate
            ? detail.total_amount * _.ceil(detail.vat_rate / 100, 4)
            : 0
          detail.amount_include_vat = _.ceil(
            detail.total_amount + detail.vat_amount,
            2
          )
        })
        this.model.payment_amount = _.sumBy(
          this.model.fee_detail_list,
          'total_amount'
        )
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
#table-details > thead > tr > th {
  padding: 5px 4px;
  background: #f2f3f4;
}
#table-details > tbody > tr > td {
  padding: 5px 4px;
  border: none !important;
  font-size: 12px !important;
}
</style>
